import React, { useState,useEffect } from 'react';
import { formatDate } from './Function';
import { Container,Card,Placeholder } from 'react-bootstrap';
import Slider from "react-slick";
import './focusUtils';
const ConvocationNews = ({sp}) => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const[isLoading, setLoading] = useState(true);
    const[hpSlider,setSlider]=useState([]);
    const stArray = {303:22,310:25};
    useEffect(()=>
    {
        const getSlider = async (stId) => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL+"slider/byType/"+stId);
                const result = await response.json();
                if(result.length > 0 )
                {
                    Promise.all(
                        result.map(e => {
                            const fetch1 = fetch(global.config.API_URL + "upload/details/0/" + e.ss_id + "/slideImage")
                                .then(upp => upp.json());
                            const fetch2 = fetch(global.config.API_URL + "upload/details/0/" + e.ss_id + "/slideImageHi")
                                .then(upb => upb.json());
                            return Promise.all([fetch1, fetch2])
                                .then(([upp, upb]) => {
                                    return {
                                        ...e,
                                        upp,
                                        upb
                                    };
                                });
                        })
                    ).then(allResponse => {   
                        allResponse.forEach((el, i) => {
                            result[i].slideImage = (el.upp.length > 0) ? global.config.uploadPath + el.upp[0].up_fname + el.upp[0].up_ext : '';
                            result[i].slideImageHi = (el.upb.length > 0) ? global.config.uploadPath + el.upb[0].up_fname + el.upb[0].up_ext : '';
                        });
                        setSlider(result);
                    }).catch(error => {
                        console.error('Slider File :', error);
                    });
                }
                if( global.config.IsPrint === false ) { console.info('Slider : Result',result); }         
            }
            catch (error) 
            {
                console.error('Slider : Error', error.message);                
            }
            finally
            {
                setLoading(false);
            }
        };
        if(sp?.sp_id > 0 )        {
            
            getSlider(stArray[sp.sp_id]);
        }
        window.disableFocusInHiddenSlides();
        window.enableFocusInVisibleSlides();
        // eslint-disable-next-line 
    },[sp]);
    const settings = 
    {
        autoplay: true,
        centerMode: false,
        infinite: true,
        centerPadding: "0px",
        dots: false,
        slidesToShow: 4,
        speed: 500,
        accessibility: true,
        arrows: true,
        beforeChange: (current, next) => { window.disableFocusInHiddenSlides(); },
        afterChange: current => { window.enableFocusInVisibleSlides(); },
        responsive: [{ breakpoint: 1024,settings: { slidesToShow: 1 }} ]
    };
    return (
        <section className='bg-info-subtle'>
            <Container className="py-md-5 py-4 text-center">
            <h2 className="text-uppercase">{appLanguage === 'hi' ? 'समाचार में आईजीडीटीयूडब्लू' : 'IGDTUW in News'}</h2>
            <span className="mb-4 sub-heading"></span>
            {isLoading ? (
                <Slider {...settings}>
                    {[...Array(5)].map((_,index)=>(
                    <div key={index} className='p-3 h-100'>
                        <Card className='text-center card-custom'>
                            <Placeholder xs={12} className="d-block w-100" style={{height:"400px"}} />
                            <Card.Body className='flex-column'>
                                <Card.Title><Placeholder xs={10} /></Card.Title>
                                <Card.Text><Placeholder xs={8} /></Card.Text>
                            </Card.Body>
                        </Card>                    
                    </div>
                    ))}
                </Slider>
                ) : (
                <Slider {...settings}>
                    {hpSlider.map((hs, index)=>(
                        <div key={index} className='p-3 h-100'>
                            <Card className='text-center card-custom'>
                                {appLanguage === 'hi' ? 
                                    (
                                        hs.ss_display_en === "1" && hs.slideImageHi ? 
                                        <Card.Img variant="top" src={hs.slideImageHi} alt={hs.ss_name_hi} loading="lazy" /> 
                                        : hs.slideImageHi ? 
                                        <Card.Img variant="top" src={hs.slideImageHi} alt={hs.ss_name_hi} loading="lazy" /> 
                                            : hs.slideImage ?
                                            <Card.Img variant="top" src={hs.slideImage} alt={hs.ss_name_hi} loading="lazy" /> 
                                            : null
                                    ) : (
                                        hs.slideImage ? 
                                        <Card.Img variant="top" src={hs.slideImage} alt={hs.ss_name} loading="lazy" /> 
                                        : null
                                    )
                                }
                                <Card.Body className='flex-column'>
                                    <Card.Title>{appLanguage === 'hi' ? hs.ss_name_hi || hs.ss_name : hs.ss_name }</Card.Title>
                                    <Card.Text>({formatDate(hs.ss_date)})</Card.Text>
                                        <a className='stretched-link' href={appLanguage === 'hi' ? hs.slideImageHi || hs.slideImage : hs.slideImage } target="_blank" rel="noopener noreferrer">
                                            <span className="visually-hidden">Read more</span>
                                        </a>
                                </Card.Body>
                            </Card>                        
                        </div>              
                    ))}
                </Slider>
            )}
            </Container>
        </section>
    );    
}
export default ConvocationNews;